import { render, staticRenderFns } from "./Rma.vue?vue&type=template&id=8c46f938&scoped=true"
import script from "./Rma.vue?vue&type=script&lang=js"
export * from "./Rma.vue?vue&type=script&lang=js"
import style0 from "./Rma.vue?vue&type=style&index=0&id=8c46f938&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c46f938",
  null
  
)

export default component.exports